export enum CascadingApplyOption {
  ALL_LEVELS = 'all-levels',
  ONLY_IF_UNCHANGED = 'only-if-unchanged',
}

export interface CascadingOptionConfig {
  value: CascadingApplyOption;
  label: string;
}

export const CASCADING_OPTIONS: CascadingOptionConfig[] = [
  {
    value: CascadingApplyOption.ALL_LEVELS,
    label: 'all levels below',
  },
  {
    value: CascadingApplyOption.ONLY_IF_UNCHANGED,
    label: 'only where unchanged',
  },
];

export const getDefaultCascadingOption = (): CascadingOptionConfig =>
  CASCADING_OPTIONS.find((option) => option.value === CascadingApplyOption.ONLY_IF_UNCHANGED) || CASCADING_OPTIONS[0];

export const getCascadingOptionByValue = (value: string): CascadingOptionConfig | undefined =>
  CASCADING_OPTIONS.find((option) => option.value === value);
